import { AsNsThatOriginatePrefixesSubscription } from "../../graphql/generated/operations";

/**
 * @param {AsNsThatOriginatePrefixesSubscription | undefined} data
 * @returns {number[] | undefined}
 */
export const formatter = (data) =>
  data?.autonomousSystems.map(({ number }) => number);
